import styled from 'styled-components'

// MOK adjustments
export const SelectionLabel = styled.label`
  /* float: none;
  font-size: 18px;
  font-family: united-sans, sans-serif;
  font-weight: 400;
  color: #1d1d1b;
  margin-top: 5px;
  margin-bottom: 5px;
  line-height: 1.1;

  + svg {
    padding-left: 5px;
    font-size: 18px;
    cursor: pointer;
  } */
`
